import { render } from "./MyAccountSetsCards.vue?vue&type=template&id=01f0047a&scoped=true"
import script from "./MyAccountSetsCards.vue?vue&type=script&lang=js"
export * from "./MyAccountSetsCards.vue?vue&type=script&lang=js"

import "./MyAccountSetsCards.vue?vue&type=style&index=0&id=01f0047a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f0047a"]])

export default __exports__